import Model, { AsyncBelongsTo, attr, belongsTo } from '@ember-data/model';
import { translated } from 'admin-panel/utils/model';

import type { TranslatedField } from 'admin-panel/constants/types';
import type HotelModel from 'admin-panel/models/hotel';
import type CategoryModel from 'admin-panel/models/category';
import type CurrencyModel from 'admin-panel/models/currency';

export default class ChargeModel extends Model {
  @belongsTo('hotel', { async: true, inverse: null })
  declare hotel: AsyncBelongsTo<HotelModel>;

  @belongsTo('category', { async: true, inverse: null })
  declare category: AsyncBelongsTo<CategoryModel>;

  @belongsTo('currency', { async: true, inverse: null })
  declare currency: AsyncBelongsTo<CurrencyModel>;

  @attr
  declare value: number;

  @attr
  declare percentage: boolean;

  @attr
  declare labelTranslations: TranslatedField;

  @translated
  declare label: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    charge: ChargeModel;
  }
}
